
import { defineComponent, reactive, toRefs } from "vue";
import {
  DoubleRightOutlined,
  DoubleLeftOutlined,
  UploadOutlined,
  CheckOutlined,
  CloseOutlined,
  UndoOutlined,
  EyeFilled
} from "@ant-design/icons-vue";
import { useRouter } from "vue-router";
import { ref } from 'vue'

export default defineComponent({
  components: {
    // DoubleLeftOutlined,
    // DoubleRightOutlined,
    // UploadOutlined
    CheckOutlined,
    CloseOutlined,
    EyeFilled
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    addText: {
      type: String,
      default: "Create",
    },
    showEmployeeUploadButton: {
      type: Boolean,
      default: false,
    },
    showTpUploadButton: {
      type: Boolean,
      default: false,
    },
    showCreateButton: {
      type: Boolean,
      default: true,
    },
    showDeleteButton: {
      type: Boolean,
      default: true,
    },
    showActivateButton: {
      type: Boolean,
      default: false,
    },
    showDeactivateButton: {
      type: Boolean,
      default: false,
    },
    showRestoreButton: {
      type: Boolean,
      default: false
    },
    showSetPermissionButton: {
      type: Boolean,
      default: false,
    },
    showEditButton: {
      type: Boolean,
      default: true,
    },
    showViewButton: {
      type: Boolean,
      default: false,
    },
    showDownloadButton: {
      type: Boolean,
      default: false,
    },
    showCommentButton: {
      type: Boolean,
      default: true,
    },
    showPassResetButton: {
      type: Boolean,
      default: false,
    },
    showSendCredentialsButton: {
      type: Boolean,
      default: false,
    },
    uploadEmployeeMasterList: {
      type: Boolean,
      default: false,
    },
    downloadVendorMasterList: {
      type: Boolean,
      default: false,
    },
    downloadVendorTemplate: {
      type: Boolean,
      default: false,
    },
    uploadVendorMasterList: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Object,
    },
    title: {
      type: String,
      required: true,
    },
    scrollOptions: {
      type: Object,
      required: false,
    },
    showUnmapDownloadButton: {
      type: Boolean,
      default: false,
    },
    showPagination: {
      type: Boolean,
      default: true,
    },
    showAssessmentEditButton: {
      type: Boolean,
      default: false,
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
    showFilter: {
      type: Boolean,
      default: false,
    },
    showApprovalsButton: {
      type: Boolean,
      default: false,
    },
    downloadAuditLogs: {
      type: Boolean,
      default: false,
    },
    rowKey: {
      type: String,
      default: 'id'
    }
  },
  emits: [
    "edit",
    "destroy",
    "create",
    "filter",
    "setPermission",
    "activate",
    "inactivate",
    "restore",
    "checked",
    "view",
    "handleTableChange",
    "download"
  ],
  setup(props, { emit }) {
    const filterOption = (inputValue: any, option: any) => {
      return option.children.join('').toLowerCase().includes(inputValue.toLowerCase());
    }
    const form = reactive({
      page: 1,
      limit: 10,
      search: "",
    });
    const router = useRouter();

    const filter = () => {
      emit("filter", form);
    };

    function createDebounce() {
      let timeout: any;
      return function (fnc: any, delayMs: any) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          const { page } = toRefs(form);
          page.value = 1;
          emit("filter", form);
        }, delayMs || 500);
      };
    }

    const onChange = (payload: any) => {
      const { page } = toRefs(form);
      page.value = payload;
      filter();
    };

    const onDestroy = (payload: any) => {
      emit("destroy", payload);
    };

    const handleTableChange = (pag:any, filters:any, sorter:any) => {
      const payload = {
        field: sorter.field,
        order: sorter.order == 'ascend' ? 'ASC' : 'DESC'
      };
      emit("handleTableChange", payload);
    }

    const onShowLimit = (current: any, pageSize: any) => {
      const { limit } = toRefs(form);
      const { page } = toRefs(form);
      page.value = 1;
      limit.value = pageSize;
      filter();
    };

    return {
      form,
      filter,
      debounce: createDebounce(),
      onChange,
      onShowLimit,
      onDestroy,
      filterOption,
      handleTableChange
    };
  },
});
